import { svg, path } from 'utils'
import icons from 'icons'
import styled from 'glamorous'
import { $ } from 'utils'

const Wrapper = styled.span({
  position: 'relative',
  display: 'inline-flex',
  verticalAlign: 'top',
  alignItems: 'center',
  zIndex: '1',
}, ({ color = 'var(--lightGrey)', 
      colorHover = 'var(--violet)',
      colorActive = 'var(--green)',
      isDisabled = false,
      isHoverable = true,
      isActive = false,
      isRoundEffect  = false }) => {
  const base = {
    color: color,
  }
  const disabled = isDisabled ? {
    opacity: '0.3',
    pointerEvents: 'none',
    cursor: 'default'
  } : {}
  const hover = isHoverable && !isDisabled ? {
    '&:hover': {
      color: colorHover,
      cursor: 'pointer'
    }
  } : {}
  const active = isActive ? {
    color: colorActive,
    '&:hover': {
      color: colorActive
    }
  } : {}
  const roundEffect = isRoundEffect && !isActive ? {
    transition: 'color var(--transition)',
    '&:before': {
      content: ' ',
      position: 'absolute',
      top: '-4px',
      right: '-4px',
      left: '-4px',
      bottom: '-4px',
      backgroundColor: 'var(--lightestGrey)',
      borderRadius: '100%',
      transform: 'scale(0)',
      transition: 'transform var(--transition)',
      zIndex: '-1'
    },
    '&:hover': {
      color: 'var(--darkGrey)',
      '&:before': {
        transform: 'scale(1)'
      }
    }
  } : {}
  return [base, disabled, hover, active, roundEffect]
})

const Icon = ({
  type = 'add',
  size = 30,
  viewBox = "0 0 32 32",
  ...props
}) =>
  $(Wrapper, {
    className: 'icon',
    ...props
  },
    svg({
      version: "1.2",
      baseProfile: "tiny",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: viewBox,
      width: size,
      height: size,
      color: 'inherit'
    },
      path({
        className: `icon-${type}`,
        fill: 'currentColor',
        d: icons[type]
      }),
    )
  )

export default Icon



// WEBPACK FOOTER //
// ./src/components/Icon.js